import { render, staticRenderFns } from "./ExternalLinkTile.vue?vue&type=template&id=07c0d47d"
import script from "./ExternalLinkTile.vue?vue&type=script&lang=js"
export * from "./ExternalLinkTile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports